import { Fragment } from 'react';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNumberSkeletons = () => /*#__PURE__*/_jsxs(Fragment, {
  children: [[...Array(3)].map((e, i) => /*#__PURE__*/_jsxs(View, {
    marginInline: "300",
    marginBlockStart: "300",
    marginBlockEnd: "0",
    as: "div",
    children: [/*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "16px",
      blockSize: "16px",
      marginInlineEnd: "100",
      display: "inline-block"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "24px",
      blockSize: "16px",
      marginInlineEnd: "100",
      display: "inline-block"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "120px",
      blockSize: "16px",
      marginInlineEnd: "100",
      display: "inline-block"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "80px",
      blockSize: "16px",
      marginInlineEnd: "100",
      display: "inline-block"
    })]
  }, `number-placeholder_${i}`)), /*#__PURE__*/_jsx(View, {
    "data-selenium-test": "calling-skeleton-state",
    margin: "300",
    as: "div",
    children: /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "180px",
      blockSize: "16px",
      marginInlineEnd: "100",
      display: "inline-block"
    })
  })]
});
export default CallNumberSkeletons;